// RolVentas.js
import React, { useState, useCallback, useEffect } from "react";
import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "bootstrap-icons/font/bootstrap-icons.css";

const RolVentas = ({ isOpen, toggleSidebar, closeSidebar }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Función para alternar un submenú
  const toggleMenu = useCallback(
    (menu) => {
      if (!isOpen) {
        // 1) Abre el sidebar
        toggleSidebar();
        // 2) Asegura que el submenú esté abierto
        setOpenMenus((prev) => ({ ...prev, [menu]: true }));
      } else {
        // Sidebar ya abierto: alterna normalmente
        setOpenMenus((prev) => ({
          ...prev,
          [menu]: !prev[menu],
        }));
      }
    },
    [isOpen, toggleSidebar]
  );

  useEffect(() => {
    setOpenMenus({});
  }, [location.pathname]);
  // Cierra todos los submenús
  const resetMenus = useCallback(() => {
    setOpenMenus({}); // Resetea todos los menús abiertos
    closeSidebar(); // Cierra el sidebar
  }, [closeSidebar]);

  const isMenuOpen = (menu) => openMenus[menu] || false;

  const handleLogout = async () => {
    await logout();
    localStorage.removeItem("userRole"); // Eliminar el rol de localStorage al cerrar sesión
    navigate("/login");
  };

  const handleLinkClick = (e, path) => {
    if (location.pathname !== path) {
      // Solo cierra el sidebar si la ruta cambia
      closeSidebar();
    }
    // Si ya estás en la misma ruta, no haces nada
  };

  // Función personalizada para manejar el clic en los iconos de plus
  const handlePlusIconClick = (e, path) => {
    e.preventDefault(); // Evita la navegación predeterminada del enlace
    e.stopPropagation(); // Previene que el evento burbujee al <Link>
    navigate(path, { state: { openModal: true } });
    closeSidebar(); // Cierra el Sidebar
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="sidebar-header">
        <div className="logo-container-sidebar">
          <Link to="/">
            <img
              className={`logo ${isOpen ? "open" : "closed"}`}
              src="/img/logo-iciamex.png"
              alt="ICIAMEX logo"
            />
          </Link>
        </div>

        <Link to="/">
          <img className="menu-icon" src="/img/ic.svg" alt="Menu Icon" />
        </Link>
        {isOpen && (
          <div className="menu-toggle-btn" onClick={resetMenus}>
            <i className="bi bi-chevron-left"></i>
          </div>
        )}
        {!isOpen && (
          <div className="sidebar-open-btn" onClick={toggleSidebar}>
            <i className="bi bi-chevron-right"></i>
          </div>
        )}
      </div>

      <div className="sidebar-content">
        <nav id="primary-menu" className="navbar">
          <ul className="nav navbar-nav">
            {isOpen && <span className="main-text">Principal</span>}
            <li
              className={`sidebar-item ${
                location.pathname === "/" ? "border-bottom-active" : ""
              }`}
              data-tooltip="Inicio"
            >
              <Link
                className={location.pathname === "/" ? "active" : ""}
                to="/"
                onClick={() => handleLinkClick("/")}
              >
                <span className="icon">
                  <i className="bi bi-house"></i>
                </span>
                <span className="text">Inicio</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${
                location.pathname === "/tareas" ? "border-bottom-active" : ""
              }`}
              data-tooltip="Tareas"
            >
              <Link
                className={location.pathname === "/tareas" ? "active" : ""}
                to="/tareas"
                onClick={() => handleLinkClick("/tareas")}
              >
                <span className="icon">
                  <i className="bi bi-check2-square"></i>
                </span>
                <span className="text">Tareas</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${
                location.pathname === "/calendario"
                  ? "border-bottom-active"
                  : ""
              }`}
              data-tooltip="Calendario"
            >
              <Link
                className={location.pathname === "/calendario" ? "active" : ""}
                to="/calendario"
                onClick={() => handleLinkClick("/calendario")}
              >
                <span className="icon">
                  <i className="bi bi-calendar2-day"></i>
                </span>
                <span className="text">Calendario</span>
              </Link>
            </li>

            <br />

            {isOpen && <span className="main-text">Utilidades</span>}
            <li
              data-tooltip="Clientes"
              className={isMenuOpen("Clientes") ? "open" : ""}
            >
              <Link
                className={`sidebar-item ${
                  isMenuOpen("Clientes") ? "border-bottom-active" : ""
                }`}
                to="#"
                onClick={() => toggleMenu("Clientes")}
                data-tooltip="Clientes"
              >
                <span className="icon">
                  <i className="bi bi-graph-up-arrow"></i>
                </span>
                <span className="text">Clientes</span>
                <div className="dropdown-arrow-container">
                  <span
                    className={`dropdown-arrow ${
                      isOpen && isMenuOpen("Clientes") ? "active" : ""
                    }`}
                  >
                    {isOpen ? (
                      isMenuOpen("Clientes") ? (
                        <i className="bi bi-chevron-up"></i>
                      ) : (
                        <i className="bi bi-chevron-right"></i>
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </Link>
              {isMenuOpen("Clientes") && (
                <ul
                  className={`sub-menu ${
                    isMenuOpen("Clientes") ? "open" : "closed"
                  }`}
                  data-tooltip="Clientes"
                >
                  <li>
                    <Link
                      className="text"
                      to="/facturas-de-clientes"
                      onClick={(e) =>
                        handleLinkClick(e, "/facturas-de-clientes")
                      }
                    >
                      <span>Facturas de Clientes</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/cotizacion"
                      onClick={(e) => handleLinkClick(e, "/cotizacion")}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>Cotizaciones</span>
                      <span
                        onClick={(e) => handlePlusIconClick(e, "/cotizacion")}
                        style={{ cursor: "pointer" }}
                      >
                        <i className="bi bi-plus-circle"></i>
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/remisiones"
                      onClick={(e) => handleLinkClick(e, "/remisiones")}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>Remisiones</span>
                      <span
                        onClick={(e) => handlePlusIconClick(e, "/remisiones")}
                        style={{ cursor: "pointer" }}
                      >
                        <i className="bi bi-plus-circle"></i>
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`text ${
                        location.pathname === "/orden-de-compra" ? "active" : ""
                      }`}
                      to="/orden-de-compra"
                      onClick={(e) => handleLinkClick(e, "/orden-de-compra")}
                      aria-label="Ordenes de Compra"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>Ordenes de Compra</span>
                      <span
                        onClick={(e) => handlePlusIconClick(e, "/orden-de-compra")}
                        style={{ cursor: "pointer" }}
                      >
                        <i className="bi bi-plus-circle"></i>
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link className="text">
                      <span>Pagos Recibidos</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/calculador"
                      onClick={(e) => handleLinkClick(e, "/calculador")}
                    >
                      <span>Calculador de Costos</span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li
              data-tooltip="Inventario"
              className={isMenuOpen("Inventario") ? "open" : ""}
            >
              <Link
                className={`sidebar-item ${
                  isMenuOpen("Inventario") ? "border-bottom-active" : ""
                }`}
                onClick={() => toggleMenu("Inventario")}
                data-tooltip="Inventario"
              >
                <span className="icon">
                  <i className="bi bi-box"></i>
                </span>
                <span className="text">Inventario</span>
                <div className="dropdown-arrow-container">
                  <span
                    className={`dropdown-arrow ${
                      isOpen && isMenuOpen("Inventario") ? "active" : ""
                    }`}
                  >
                    {isOpen ? (
                      isMenuOpen("Inventario") ? (
                        <i className="bi bi-chevron-up"></i>
                      ) : (
                        <i className="bi bi-chevron-right"></i>
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </Link>
              {isMenuOpen("Inventario") && (
                <ul
                  className={`sub-menu ${
                    isMenuOpen("Inventario") ? "open" : "closed"
                  }`}
                >
                  <li>
                    <Link
                      className="text"
                      to="/articulos-venta"
                      onClick={(e) => handleLinkClick(e, "/articulos-venta")}
                    >
                      <span>Artículos de Venta</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/articulos-compra"
                      onClick={(e) => handleLinkClick(e, "/articulos-compra")}
                    >
                      <span
                        onClick={(e) => handleLinkClick(e, "/articulos-compra")}
                      >
                        Artículos de Compra
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link className="text">
                      <span>Ajustes de Inventario</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="text">
                      <span>Gestión de Productos</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/categorias"
                      onClick={(e) => handleLinkClick(e, "/categorias")}
                    >
                      <span>Categorías</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="text">
                      <span>Almacenes</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/grupos"
                      onClick={(e) => handleLinkClick(e, "/grupos")}
                    >
                      <span>Grupos</span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <div
              style={{
                position: "relative",
                width: "100%",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  bottom: "0",
                  left: "50%",
                  transform: "translateX(-50%)",
                  borderBottom: isOpen ? "1px solid #4C5165" : "none",
                  width: isOpen ? "85%" : "auto",
                }}
              ></div>
            </div>

            <br />

            {isOpen && <span className="main-text">Registros</span>}
            <li
              data-tooltip="Contactos"
              className={isMenuOpen("Contactos") ? "open" : ""}
            >
              <Link
                className={`sidebar-item ${
                  isMenuOpen("Contactos") ? "border-bottom-active" : ""
                }`}
                data-tooltip="Contactos"
                to="#"
                onClick={() => toggleMenu("Contactos")}
              >
                <span className="icon">
                  <i className="bi bi-telephone"></i>
                </span>
                <span className="text">Contactos</span>
                <div className="dropdown-arrow-container">
                  <span
                    className={`dropdown-arrow ${
                      isOpen && isMenuOpen("Contactos") ? "active" : ""
                    }`}
                  >
                    {isOpen ? (
                      isMenuOpen("Contactos") ? (
                        <i className="bi bi-chevron-up"></i>
                      ) : (
                        <i className="bi bi-chevron-right"></i>
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </Link>
              {isMenuOpen("Contactos") && (
                <ul
                  className={`sub-menu ${
                    isMenuOpen("Contactos") ? "open" : "closed"
                  }`}
                >
                  <li>
                    <Link
                      className="text"
                      to="/todos"
                      onClick={(e) => handleLinkClick(e, "/todos")}
                    >
                      <span onClick={(e) => handleLinkClick(e, "/todos")}>
                        Todos
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/clientes"
                      onClick={(e) => handleLinkClick(e, "/clientes")}
                    >
                      <span onClick={(e) => handleLinkClick(e, "/clientes")}>
                        Clientes
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/proveedores"
                      onClick={(e) => handleLinkClick(e, "/proveedores")}
                    >
                      <span onClick={(e) => handleLinkClick(e, "/proveedores")}>
                        Proveedores
                      </span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </nav>

        {isOpen && (
          <div
            style={{
              display: "flex",
              flexDirection: "column", // Asegura que los elementos estén en columna
              alignItems: "center", // Centra el contenido en el sidebar
              width: "100%",
              height: "30%", // Ocupa toda la altura disponible
            }}
          >
            <div style={{ flexGrow: 1 }} />
            <button
              onClick={handleLogout}
              style={{
                padding: isOpen ? "15px 20px" : "10px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#4C5165",
                color: "#e0e0e0",
                borderRadius: "8px",
                fontSize: isOpen ? "14px" : "12px",
                width: isOpen ? "80%" : "40px",
                height: isOpen ? "auto" : "40px",
                margin: "10px auto 20px auto", // Espaciado inferior ajustado
                cursor: "pointer",
                border: "none",
                transition: "all 0.3s ease-in-out",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#626879")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#4C5165")}
            >
              <i
                style={{
                  marginRight: isOpen ? "10px" : "0",
                  fontSize: "16px",
                  transition: "margin 0.3s ease-in-out",
                }}
                className="bi bi-box-arrow-in-right"
              ></i>
              {isOpen && <span>Cerrar Sesión</span>}
            </button>
          </div>
        )}
        <Outlet />
      </div>
    </div>
  );
};

export default RolVentas;
